import { useState, useEffect } from 'react';
import { getStudent, getStudents } from '../../services/scpApi';
import { studentStatuses } from '../../data/data';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedSchool, setSelectedStudent, setSelectedYearGroup } from '../../slices/portalSelectedSlice';
import { useNavigate } from 'react-router-dom';
import { defaultPageLimit } from '../../data/data';
import CrudStudentListFilters from './CrudStudentListFilters';
import Paginator from '../paginator/Paginator';
import dotsVertical from '../../assets/dots-vertical.svg';


const CrudStudentsList = ({ setSelectedSingleItemId, setView }) => {

    const [filters, setFilters] = useState({
        school: null,
        yearGroup: null,
        tutorGroup: null,
    });
    const [students, setStudents] = useState([]);
    const [message, setMessage] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectedStudent = useSelector(state => state.portalSelected.selectedStudent);


    const getStatusName = (status) => {
        const statusObj = studentStatuses.find(item => item.status === status);
        return statusObj ? statusObj.name : status;
    };

    useEffect(() => {
        console.log('Selected student in global state: ', selectedStudent);
    }, [selectedStudent])

    // fetch students
    useEffect(() => {
        (async () => {
            if (!filters.school) {
                setMessage('Please select a school');
                setStudents([]);
                return;
            }

            try {
                // fetch students data
                const data = await getStudents({
                    schoolId: filters.school ? filters.school.id : null,
                    yearGroup: filters.yearGroup ? filters.yearGroup.year : null,
                    tutorGroupId: filters.tutorGroup ? filters.tutorGroup.id : null,
                    includePeriods: true,
                    includeTutorGroup: true,
                    page: currentPage,
                    limit: defaultPageLimit,

                });

                // collect the relevant data from the response
                let students = data?.pupil.map(student => {
                    const latestPeriod = student.pupil_periods[student.pupil_periods.length - 1] || {};

                    return {
                        id: student.id,
                        name: student.name,
                        yearGroup: latestPeriod.year_group || 'N/A',
                        tutorGroup: latestPeriod.tutor_group ? latestPeriod.tutor_group.name : 'N/A',
                        studentStatus: getStatusName(latestPeriod.pupil_status || 'N/A'),
                    };
                });

                // order students by name alphabetically
                students = students.sort((a, b) => a.name.localeCompare(b.name));

                // set the students data
                setStudents(students);
                setMessage(students.length > 0 ? '' : 'No students found');

                // set pagination data
                setPagination({
                    total: data?.total || 0,
                    currentPage: data?.current_page || 1,
                    perPage: data?.per_page || defaultPageLimit,
                    lastPage: data?.last_page || 1,
                });
            } catch (error) {
                console.error('Error fetching students:', error);
                setMessage('Error fetching students');
                setStudents([]);
            }
        })();

    }, [filters.school, filters.yearGroup, filters.tutorGroup, currentPage]);

    const handleEditClick = async (student) => {
        try {
            if (!student.id) {
                setMessage('Please select a student');
                return;
            }

            const studentData = await getStudent(student.id);
            const studentSchool = studentData?.school || {};
            const studentYearGroup = studentData?.pupil_periods?.length > 0 ? studentData.pupil_periods[studentData.pupil_periods.length - 1]?.year_group : {};
            const studentYearGroupObj = {
                name: `Year ${studentYearGroup}`,
                year: studentYearGroup,
            }

            dispatch(setSelectedStudent(studentData));
            dispatch(setSelectedSchool(studentSchool));
            dispatch(setSelectedYearGroup(studentYearGroupObj));

            // setTimeout(() => {
            navigate('/portal/students/update-student-progress');
            // }, 500);       
        } catch (error) {
            console.log(error);
            setMessage('Failed to fetch student details');
        }
    };


    const clearFilters = () => {
        setFilters({
            school: null,
            yearGroup: null,
            tutorGroup: null,
        });
    }

    const columns = [
        { columnLabel: 'Name', dataKey: 'name' },
        { columnLabel: 'Year Group', dataKey: 'yearGroup' },
        { columnLabel: 'Tutor Group', dataKey: 'tutorGroup' },
        { columnLabel: 'Student Status', dataKey: 'studentStatus' }
    ];

    return (
        <Paginator
            pagination={pagination}
            onPageChange={(page) => setCurrentPage(page)}
        >
            <div className="">
                <CrudStudentListFilters filters={filters} setFilters={setFilters} />
                <a onClick={() => clearFilters()} className="clear-filters-btn">Clear Filters</a>
                <div className="separator"></div>
                <div className='pagination-count'>Showing {students.length} of {students.length} student{students.length !== 1 ? 's' : ''}</div>
                <div className='crud-list'>
                    <table className='custom-table'>
                        <thead>
                            <tr>
                                {columns.map(column => (
                                    <th key={column.columnLabel}>{column.columnLabel}</th>
                                ))}
                                <th>View / Edit</th>
                            </tr>
                            <tr className="separator-row"></tr>
                        </thead>

                        <tbody>
                            {message ? (
                                <tr>
                                    <td colSpan={columns.length + 1}>{message}</td>
                                </tr>
                            ) : (
                                students.length > 0 ? (
                                    students.map(student => (
                                        <tr key={student.id}>
                                            {columns.map(column => (
                                                <td key={column.dataKey}>{student[column.dataKey]}</td>
                                            ))}
                                            <td className='edit-dots'>
                                                <button
                                                    onClick={() => handleEditClick(student)}
                                                    className='edit-dots'>
                                                    <img src={dotsVertical} alt="Edit" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={columns.length + 1}>No students found</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
        </Paginator>
    );
};

export default CrudStudentsList;